var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8ZM6.36185 10.5019C6.16659 10.6972 5.85001 10.6972 5.65475 10.5019C5.45949 10.3067 5.45949 9.99007 5.65475 9.79481L7.42221 8.02734L5.65422 6.25935C5.45896 6.06409 5.45896 5.74751 5.65422 5.55224C5.84948 5.35698 6.16606 5.35698 6.36133 5.55224L8.12932 7.32024L9.89739 5.55217C10.0927 5.35691 10.4092 5.35691 10.6045 5.55217C10.7998 5.74743 10.7998 6.06401 10.6045 6.25927L8.83643 8.02734L10.604 9.79488C10.7992 9.99015 10.7992 10.3067 10.604 10.502C10.4087 10.6973 10.0921 10.6973 9.89686 10.502L8.12932 8.73445L6.36185 10.5019Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.118df73171f84566a5f2e6bcad9180ea.svg";
export { ForwardRef as ReactComponent };